export const talks = [
  {
    id: 1,
    image: "/assets/Institution/talk10.png",
    // institution: "BITS Pilani - Goa",
    date: "September 3, 2024",
  },
  {
    id: 2,
    image: "/assets/Institution/talk1.jpg",
    // institution: "ISHRAE, Jaipur",
    date: "August 1, 2024",
  },
  {
    id: 3,
    image: "/assets/Institution/talk2.jpg",
    // institution: "IIT Delhi",
    date: "April 15, 2024",
  },
  {
    id: 4,
    image: "/assets/Institution/talk3.png",
    // institution: "NIT Trichy",
    date: "April 8, 2024",
  },
  {
    id: 5,
    image: "/assets/Institution/talk11.png",
    // institution: "IIT Hyderabad",
    date: "February 2, 2024",
  },
  {
    id: 6,
    image: "/assets/Institution/talk9.png",
    // institution: "IIT Hyderabad",
    date: "February 2, 2024",
  },
  {
    id: 7,
    image: "/assets/Institution/talk8.png",
    // institution: "NIT Trichy",
    date: "April 8, 2024",
  },
  {
    id: 9,
    image: "/assets/Institution/talk7.png",
    // institution: "NIT Trichy",
    date: "April 8, 2024",
  },
  {
    id: 10,
    image: "/assets/Institution/talk6.png",
    // institution: "NIT Trichy",
    date: "April 8, 2024",
  },
];
